// Utility function to split PDF content into pages
export const splitPDFContent = (htmlContent) => {
  if (!htmlContent) return ['<p>Start typing to see preview...</p>'];
  
  console.log('=== PDF Content Splitting ===');
  console.log('Input HTML length:', htmlContent.length);
  console.log('Full HTML content:', htmlContent);
  console.log('First 500 chars:', htmlContent.substring(0, 500));
  
  // Check for page break markers
  const hasPageBreak = htmlContent.includes('page-break') || 
                      htmlContent.includes('pagebreak');
  
  console.log('Has page break marker:', hasPageBreak);
  
  if (!hasPageBreak) {
    console.log('No page breaks found, returning single page');
    return [htmlContent];
  }
  
  // Use a more comprehensive approach for different page break formats
  // Look for both Quill-inserted page breaks and our custom ones
  const pageBreakRegex = /<div[^>]*(?:class="[^"]*page-break[^"]*"|data-blot="pagebreak")[^>]*>[\s\S]*?<\/div>|<p[^>]*class="[^"]*pagebreak[^"]*"[^>]*>[\s\S]*?<\/p>/gi;
  
  // Find all page break matches
  const pageBreaks = htmlContent.match(pageBreakRegex);
  console.log('Found page breaks:', pageBreaks ? pageBreaks.length : 0);
  
  if (pageBreaks && pageBreaks.length > 0) {
    // Split the content by page breaks
    let parts = htmlContent.split(pageBreakRegex);
    
    // Filter out empty parts
    const pages = parts
      .map(part => part.trim())
      .filter(part => part && part.length > 0);
    
    console.log('Split into pages:', pages.length);
    
    if (pages.length > 0) {
      console.log('=== Final Result ===');
      pages.forEach((page, index) => {
        console.log(`Page ${index + 1} preview:`, page.substring(0, 100));
      });
      return pages;
    }
  }
  
  // If we get here, no page breaks were found or split didn't work
  console.log('No successful page split, returning original content as single page');
  return [htmlContent];
};

// Helper function to insert page breaks at specific positions
export const insertPageBreakAt = (content, position) => {
  const pageBreakHTML = '<div class="page-break" data-page-break="true" style="page-break-after: always;"></div>';
  
  // If position is at the end, just append
  if (position >= content.length) {
    return content + pageBreakHTML;
  }
  
  // Insert at position
  return content.slice(0, position) + pageBreakHTML + content.slice(position);
};

// Helper to estimate if content needs page breaks
export const estimatePageBreaks = (htmlContent, pageHeightMm = 297, marginsMm = 40) => {
  // Very rough estimation: ~3000 characters per page
  const effectiveHeight = pageHeightMm - marginsMm;
  const charsPerPage = effectiveHeight * 10; // Rough estimate
  
  const contentLength = htmlContent.replace(/<[^>]*>/g, '').length; // Strip HTML tags
  const estimatedPages = Math.ceil(contentLength / charsPerPage);
  
  return {
    needsPageBreaks: estimatedPages > 1,
    estimatedPages,
    charsPerPage
  };
};